import { TableCell, TableRow } from "@mui/material";
import { EntityId, EntityState } from "@reduxjs/toolkit";
import React, { useEffect, useState } from "react";
import { FaRegChartBar } from "react-icons/fa";
import { MdModeEdit } from "react-icons/md";
import { ExperienceCard } from "../../types/types";
import { StudentButton } from "./experienceListPresentation.styles";

import {
  useSortable
} from '@dnd-kit/sortable';
import { CSS } from "@dnd-kit/utilities";
import { useAppSelector } from "../../../../app/hooks";
import { images } from "../../../../constants";
import { selectAdmin } from "../../../auth/authSlice/authSlice";
import { useGetChildExperineceQuery } from "../../api/experienceCardApiSlice";
import ExperienceHotSpotSubList from "../../container/experienceHotspotSubList/ExperienceHotSpotSubList";
import ExperiencePrerequisiteList from "../../container/experiencePrerequisiteList/ExperiencePrerequisiteList";
type ExperienceListItemPresentationProps = {
  item: ExperienceCard;
  onEdit: (id: EntityId) => void;
  onPlus: (id: EntityId) => void;
  onReview: (id: EntityId) => void;
  onDelete: (id: EntityId) => void;
  list?: EntityState<ExperienceCard>
};
const ExperienceListItemPresentation: React.FC<
ExperienceListItemPresentationProps
> = ({ item, onEdit, onReview, onDelete , onPlus,list}) => {
  const {data:childList} = useGetChildExperineceQuery({prerequisiteId:item!._id! as EntityId})
  const admin = useAppSelector(selectAdmin)
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    setActivatorNodeRef
  } = useSortable({
    id:item._id,
    disabled: item.timingType !== 'Delayed'
  })

  const accessProject = admin?.projectAccess?.find(
    (project) => project.accessType === 'Full'
  )
  const accessCategory = admin?.categoryAccess?.find(
    (category) => category.accessType === 'Full'
  )
  const accessSubCategory = admin?.subCategoryAccess?.find(
    (sub) => sub.accessType === 'Full'
  )
  const permissionResult = accessProject || accessCategory || accessSubCategory
  const [showsub, setShowSub] = useState<boolean>(false)
const [itemState,setItemState] = useState<string | null>(null);

useEffect(() => {
if(childList && childList.length > 0){
setShowSub(false)
}else{
  setShowSub(false)
}
},[childList])

console.log('sdfsdfsdfsdfwww', item.timingType);

  return (
    <>
    {!item.prerequisite && ( <TableRow ref={setNodeRef}  style={{
       transform:CSS.Transform.toString(transform),
       transition,
          borderRadius: 10,
          outline: "1px solid #AEAEAE",
          marginBottom: 10 ,
          position:'relative',

          cursor: item.timingType === 'Delayed' ? 'grab' : 'default',
          userSelect:'none' as const
        }}  >
   <TableCell  style={{

          padding: 0,
          fontFamily: 'Poppins',
          position:'absolute',
          left:-59,
          top:13,
          border:'none'
        }} >
        
            <button
              onClick={() => {onDelete(item._id as EntityId)}}
              style={{
                background: 'none',
                border: 'none',
                fontSize: 'x-large',
              }}
            >
               <img style={{width:18}} src={images.Trash} alt="Delete Experience"></img>
            </button>
          
        </TableCell>
        <TableCell style={{

          padding: 0,
          fontFamily: 'Poppins',
          position:'absolute',
          left:-36,
          top:18,
          border:'none',
          zIndex:15000
        }}>
        
            <button
              onClick={(e:React.MouseEvent) => {
                e.stopPropagation();
                
                onPlus(item._id)
              }}
              style={{
                background: 'none',
                border: 'none',
                fontSize: 'x-large',
                paddingLeft: 2,
                color: '#2f8f6c'
              }}
            >
               <img style={{width:26}} src={images.AddExp} alt="Add Experience"></img>
            </button>
          
        </TableCell>

        <TableCell style={{
          maxWidth: 10,
          padding: '8px 16px',
          fontFamily: 'Poppins'
        }} ref={item.timingType === 'Delayed' ? setActivatorNodeRef : null} {...(item.timingType === 'Delayed' ? {...attributes, ...listeners} : {})}>

            <button
              onClick={() => {
              }}
              style={{
                background: 'none',
                border: 'none',
                fontSize: 'x-large',
                paddingLeft: 2,
                color: '#2f8f6c',
                opacity: item.timingType === 'Delayed' ? 1 : 0.3,
                cursor: item.timingType === 'Delayed' ? 'grab' : 'not-allowed'
              }}
            >
               <img style={{width:10}} src={images.ExpDrag} alt="Experience"></img>
            </button>

        </TableCell>
        <TableCell style={{
          maxWidth: 10,
          padding: '8px 16px',
          fontFamily: 'Poppins'
        }}>
          {childList?.length! > 0
            ? (
            <button
              onClick={() => {
                setItemState(item._id.toString())
                setShowSub(!showsub)
              }}
              style={{
                background: 'none',
                transform: showsub ? 'rotate(90deg)' : '', 
                border: 'none',
                fontSize: 'x-large',
                paddingLeft: 2,
                color: '#2f8f6c'
              }}
            >
               <img style={{width:13}} src={images.ExpArrow} alt="Experience"></img>
            </button>
              )
            : null}
        </TableCell>
        <TableCell style={{
           padding: '10px 16px 4px',
        }}>
          <img
            style={{
              width: 40,
              height: 40,
              borderRadius: 50,
              border: "1px solid #CBCBCB"
            }}
            src={item.image}
            alt=""
          />{' '}
        </TableCell>
        <TableCell style={{
          maxWidth: 130,
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins'
        }}>{item.title}</TableCell>
        <TableCell  style={{
          maxWidth: 285,
          textAlign: 'left',
          padding: '13px 16px',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins',
          WebkitLineClamp:2,
          WebkitBoxOrient:'vertical',
          overflow:'hidden',
          paddingBottom:0,
          border:'none',
          display:'-webkit-inline-box',
          height:'50px',
          alignContent:'center'
        }}>{item.description}</TableCell>
        <TableCell style={{
          maxWidth: 130,
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins'
        }}>
          {item.timingType === 'Delayed' ? (
            <div style={{
              border: '1px solid #CED4DA',
              borderRadius: 5,
              padding: '4px 8px',
              fontSize: 12,
              marginLeft: 7
            }}>
              Delay after previous {item.delayDays || 0} days
            </div>
          ) : item.timingType === 'StartDate' ? (
            <>
              <div style={{
                border: '1px solid #CED4DA',
                borderRadius: 5,
                width: 100,
                fontSize: 14,
                marginLeft: 7,
                marginBottom: 2
              }}>
                StartDate: {new Date(item.startDate).toLocaleDateString()}
              </div>
              <div style={{
                border: '1px solid #CED4DA',
                borderRadius: 5,
                width: 100,
                fontSize: 14,
                marginLeft: 7
              }}>
                Days: {Math.ceil((new Date(item.endDate).getTime() - new Date(item.startDate).getTime()) / (1000 * 60 * 60 * 24))}
              </div>
            </>
          ) : (
            <>
              <div style={{
                border: '1px solid #CED4DA',
                borderRadius: 5,
                width: 100,
                fontSize: 14,
                marginLeft: 7,
                marginBottom: 2
              }}>StartDate: {new Date(item.startDate).toLocaleDateString()}</div>
              <div style={{
                border: '1px solid #CED4DA',
                borderRadius: 5,
                width: 100,
                fontSize: 14,
                marginLeft: 7
              }}>EndDate: {new Date(item.endDate).toLocaleDateString()}</div>
            </>
          )}
        </TableCell>
        <TableCell style={{
          maxWidth: 130,
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins'
        }}> - </TableCell>
        <TableCell style={{
          maxWidth: 130,
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins'
        }}>{item.xpCompletion}</TableCell>
        <TableCell style={{
          maxWidth: 130,
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins'
        }}>{item.experienceType.title}</TableCell>
        <TableCell style={{
          maxWidth: 100,
          padding: '8px 16px',
          textAlign: 'center',
          fontSize: 12,
          justifyContent: 'center',
          fontFamily: 'Poppins'
        }}>{item.completionType.title}</TableCell>
        <TableCell style={{ overflow: 'visible' ,  padding: '8px 16px' }}>
          <div style={{ display: 'flex' , justifyContent:'end' }}>
            <StudentButton
              style={{
                display: 'flex',
                alignItems: 'center',
                marginRight: 12,
                marginLeft: 2,
                padding: 8
              }}
              onClick={() => {
                onEdit(item._id)
              }}
              spaceLeft={''}
              disabled={
                admin?.adminLevel === 'ADMIN' && !permissionResult?.experience
              }
            >
              <span
                className="experience-item-button"
                style={{
                  maxWidth: 130,
                  textAlign: 'center',
                  fontSize: 10,
                  justifyContent: 'center',
                  fontFamily: 'Poppins',
                  fontWeight: 400,
                  paddingRight: 8
                }}
              >
                Edit
              </span>
              <MdModeEdit color="#34c38f" size="20" style={{ backgroundColor: '#fff', borderRadius: 50, padding: 3 }} />
            </StudentButton>
            <StudentButton
              style={{ display: 'flex', alignItems: 'center', marginLeft: 3, paddingRight: 5 }}
              onClick={() => {
                onReview(item._id)
              }}
              spaceLeft={''}
            >
              <span
                className="experience-item-button"
                style={{
                  maxWidth: 130,
                  textAlign: 'center',
                  fontSize: 10,
                  justifyContent: 'center',
                  fontFamily: 'Poppins',
                  fontWeight: 400,
                  paddingRight: 5
                }}
              >
                Review
              </span>
              <FaRegChartBar />
            </StudentButton>
          </div>
        </TableCell>
      </TableRow>)}
     
      {showsub
        ? (
        <ExperienceHotSpotSubList
          hotspotgroupid={item.hotSpot_group_id!}
          category={item.category}
          subCategory={item.subCategory}
          expPublish={item.expPublish}
          expSave={item.expSave}
          onEdit={onEdit}
          onReview={onReview}
          term="null"
        />
          )
        : null}

{showsub ? ( <ExperiencePrerequisiteList
           prerequisiteId={itemState!}
          onEdit={onEdit}
          onReview={onReview}
          admin={admin}
          permissionResult={permissionResult}
          list={childList}
        />): null}
      
      
        
    </>
  )
}

export default ExperienceListItemPresentation
